import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import debounce from "lodash/debounce";

import "./ToolContent.scss";
import label from "../../../../i18n/label";
import Message from "../../../../i18n/Message";
import { updateToolPlugin } from "../store/toolPluginActionCreators";
import { useParams } from "react-router-dom";
import MessageTextContainer from "../../chats/details/MessageTextContainer";
import ToolsSection from "./tools/ToolsSection";
import EditIcon from "../../../../assets/icons/EditIcon";
import CheckIcon from "../../../../assets/icons/CheckIcon";

const ToolContent = ({ tool }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();

  const [editableDescription, setEditableDescription] = useState(
    tool.description || ""
  );
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  const [saveInProgress, setSaveInProgress] = useState(false);

  useEffect(() => {
    if (tool) {
      setEditableDescription(tool.description || "");
      setIsEditingDescription(false);
    }
  }, [tool]);

  const onEditDescriptionClick = () => {
    setEditableDescription(tool.description || "");
    setIsEditingDescription(true);
  };

  const onSaveDescription = () => {
    setSaveInProgress(true);
    const onFinished = () => {
      setSaveInProgress(false);
      setIsEditingDescription(false);
    };
    dispatch(
      updateToolPlugin(
        intl,
        workspaceId,
        tool.uid,
        {
          description: editableDescription,
        },
        onFinished,
        onFinished
      )
    );
  };

  const onCancelDescriptionEdit = () => {
    setEditableDescription(tool.description || "");
    setIsEditingDescription(false);
  };

  const onDescriptionChange = (e) => {
    const value = e.target.value;
    setEditableDescription(value);
  };

  return (
    <div className="tool_content_container">
      <div className="tool_content_main">
        <div className="content_section">
          <div className="section_header">
            <h3>
              <Message id="tool_description_label" />
            </h3>
            <div className="header_actions">
              {saveInProgress && (
                <div className="save_status">
                  <Message id="saving" />
                </div>
              )}
              {!isEditingDescription && (
                <button
                  className="btn btn-link edit_icon_btn"
                  onClick={onEditDescriptionClick}
                  title={label(intl, "edit")}
                >
                  <EditIcon size="16" color="#cb0c9f" />
                </button>
              )}
            </div>
          </div>
          {!isEditingDescription ? (
            <div className="markdown_content">
              {tool.description ? (
                <MessageTextContainer>{tool.description}</MessageTextContainer>
              ) : (
                <div className="empty_description">
                  {label(intl, "tool_description_placeholder")}
                </div>
              )}
            </div>
          ) : (
            <div className="edit_section">
              <textarea
                className="form-control tool_textarea"
                placeholder={label(intl, "tool_description_placeholder")}
                value={editableDescription}
                onChange={onDescriptionChange}
                rows={6}
              />
              <div className="edit_actions">
                <button
                  className="btn btn-outline-dark btn-sm"
                  onClick={onSaveDescription}
                >
                  <CheckIcon size="16" color="#344767" strokeWidth="2" />
                  <Message id="save" />
                </button>
                <button
                  className="btn no-btn btn-sm"
                  onClick={onCancelDescriptionEdit}
                >
                  <Message id="cancel" />
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="content_section">
          <div className="section_header">
            <h3>
              <Message id="tools_section_title" />
            </h3>
          </div>
          <ToolsSection toolPlugin={tool} />
        </div>
      </div>
    </div>
  );
};

export default ToolContent;
